import { render, staticRenderFns } from "./VideoGalleryPage.vue?vue&type=template&id=25aa298b&scoped=true&"
import script from "./VideoGalleryPage.vue?vue&type=script&lang=js&"
export * from "./VideoGalleryPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoGalleryPage.vue?vue&type=style&index=0&id=25aa298b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa298b",
  null
  
)

export default component.exports